import { Box, Typography } from '@mui/material';

export const CgmImportPage = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        CGM Import (N2)
      </Typography>
      <Typography color="text.secondary">
        CGM file upload workflow coming soon...
      </Typography>
    </Box>
  );
};
